module.exports = __webpack_public_path__ + "img/imagen_parrafo_7.8130b0a7.png";